import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { Provider } from "@angular/core";
import { AuthInterceptor } from "./auth.interceptor.service";
import { ErrorHandlerInterceptor } from "./error-handler-interceptor.service";

export const interceptors: Provider[] = [
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
];

